// Ad providers expect a format in the form of [[width, height]]
// It is up to the ad provider to choose the best ad format for the given space
// We need to make sure we reserve the space for the ad before it loads
//
// For more information: https://developers.google.com/publisher-tag/guides/ad-sizes#multi-size_ads
export const adFormatMapping = {
	'1x1': [[1, 1]],
	'300x250': [[300, 250]],
	'320x100': [[320, 100]],
	'300x600': [
		[300, 250],
		[300, 600],
	],
	'728x90': [[728, 90]],
	'1000x90': [[1000, 90]],
};

export type AdFormat = keyof typeof adFormatMapping;
export type AdSize = (typeof adFormatMapping)[AdFormat];

export type AdFormats = AdFormat | { mobile?: AdFormat; desktop?: AdFormat };
